import React from 'react';
import MarketerNavbar from './MarketerNavbar';
import MarketerHero from './MarketerHero';
import MarketerPainPoints from './MarketerPainPoints';
import MarketerFeatures from './MarketerFeatures';
import MarketerPricing from './MarketerPricing';
import MarketerSocialProof from './MarketerSocialProof';
import MarketerUseCases from './MarketerUseCases';
import MarketerFAQ from './MarketerFAQ';
import MarketerFooter from './MarketerFooter';
import { usePageMeta } from '../../../lib/usePageMeta';

const MarketerPage: React.FC = () => {
  usePageMeta({ title: 'For Marketers', description: 'Licensed professional data for marketers. Build targeted lists of Realtors, Dentists, and Insurance Agents with verified contact info.', path: '/marketers' });
  return (
    <div className="bg-slate-950 min-h-screen text-slate-300 font-sans antialiased selection:bg-sky-500/30 selection:text-sky-200">
      <MarketerNavbar />
      <main>
        <MarketerHero />
        <MarketerPainPoints />
        <MarketerFeatures />
        <MarketerUseCases />
        <MarketerSocialProof />
        <MarketerPricing />
        <MarketerFAQ />
      </main>
      <MarketerFooter />
    </div>
  );
};

export default MarketerPage;